export namespace BannerConstants {
  export const BANNER_TYPE_CODE_INFO: string = 'INFO';
  export const BANNER_TYPE_CODE_APP_RELEASE: string = 'APPRELEASE';
  export const BANNER_TYPE_CODE_NO_NETWORK: string = 'NONETWORK';
  export const BANNER_TYPE_CODE_DRIVER_SUSPENDED: string = 'DRIVERSUSPENDED';
  export const BANNER_TYPE_CODE_DOCUMENTS_EXPIRING: string = 'DOCUMENTSEXPIRING';
  export const BANNER_TYPE_CODE_DOCUMENTS_EXPIRED: string = 'DOCUMENTEXPIRED';
  export const BANNER_TYPE_CODE_SIGNATURES_EXPIRING: string = 'SIGNATURESEXPIRING';
  export const BANNER_TYPE_CODE_SIGNATURES_EXPIRED: string = 'SIGNATURESEXPIRED';
  export const BANNER_TYPE_CODE_DRUG_SCREENING_REQUIRED: string = 'DRUGSCREENINGREQUIRED';
  export const BANNER_TYPE_CODE_VIN_CAPTURE: string = 'VINCAPTURE';
  export const BANNER_TYPE_CODE_VEHICLE_OWNERSHIP_CAPTURE: string = 'VEHICLEOWNERSHIPCAPTURE';
  export const BANNER_TYPE_CODE_MIDDLE_NAME_CAPTURE: string = 'MIDDLENAMECAPTURE';
  export const BANNER_TYPE_CODE_BACKGROUND_CHECK_CONSENT: string = 'BACKGROUNDCHECKCONSENT';
  export const SCREENING_INFO_CAPTURE: string = 'SCREENINGINFOCAPTURE';
  export const BANNER_TYPE_CODE_SEX_AND_CITY_CAPTURE = 'SEXANDCITYCAPTURE';

  export const BANNER_SEVERITY_CODE_INFO: string = 'INFO';
  export const BANNER_SEVERITY_CODE_IMPORTANT: string = 'IMPORTANT';
  export const BANNER_SEVERITY_CODE_CRITICAL: string = 'CRITICAL';
  export const BANNER_SEVERITY_CODE_SUCCESS: string = 'SUCCESS';

  export const DRIVER_TAX_DOCUMENTS_AVAILABLE: string = 'TAXDOCUMENTSAVAILABLE';
}
